import React from 'react';
// 人员标签属性展示 （未认证、外部、单位领导、管理员等）
const tags = [
  'EXTERNAL', // 外部
  'UN_ENABLE', // 已停用
  'unEnable', // 已停用
  'OWNER', // 所有者
];

const hexToRgb = (hex: string) => {
  hex = hex.replace('#', '');

  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  return 'rgba(' + r + ', ' + g + ', ' + b + ', 0.1)';
};

export function TagsNode(labelInfoList: any[]) {
  return labelInfoList?.map((label: any, key: number) => {
    if (label.isShow === '1' && tags.includes(label.labelEnum)) {
      return (
        <span
          key={key}
          style={{
            color: `#${label.color}`,
            marginLeft: '5px',
            fontSize: 10,
            padding: '0 4px',
            // border: `.5px solid #${label.color}`,
            backgroundColor: hexToRgb(label.color),
            borderRadius: '2px',
            whiteSpace: 'nowrap',
            // marginBottom: '5px',
            height: '16px',
            lineHeight: '15px',
          }}
        >
          {label.name}
        </span>
      );
    }
    return null;
  });
}
